import React, { createContext, useContext, useMemo } from 'react';
import { DEFAULT_LOCALE } from '@/constants';

interface TranslationContextValue {
	translations: Record<string, Record<string, any>>;
	locale: string;
}

const TranslationContext = createContext<TranslationContextValue | undefined>(
	undefined,
);

interface TranslationProviderProps {
	children: React.ReactNode;
	translations?: Record<string, Record<string, any>>;
	locale?: string;
}

export const TranslationProvider: React.FC<TranslationProviderProps> = ({
	children,
	translations = {},
	locale = DEFAULT_LOCALE,
}) => {
	const value = useMemo(
		() => ({ translations, locale }),
		[translations, locale],
	);
	return (
		<TranslationContext.Provider value={value}>
			{children}
		</TranslationContext.Provider>
	);
};

export const useTranslationContext = () => {
	const context = useContext(TranslationContext);
	return context || { translations: {}, locale: DEFAULT_LOCALE };
};
